module.exports = __webpack_public_path__ + "media/npc_dota_hero_bounty_hunter.3a97d378.webm";